/**
 * Polyfill URL and URLSearchParams
 *
 * [MDN Doc - URL](https://developer.mozilla.org/en-US/docs/Web/API/URL)
 * [MDN Doc - URLSearchParams](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
 *
 * Alternative polyfills:
 *
 * - url-search-params-polyfill
 * - core-js/features/url
 * - core-js/features/url-search-params
 */
import 'url-polyfill';

import * as Sentry from '@sentry/browser';

import './form';
import './translate';

import { useReady } from './utils/dom';

import initTracking from './tracking';
import initLocationSearch from './location';
import initNav from './nav';
import initSurgeon from './surgeon';
import initFooter from './footer';
import initScheduler from './scheduler';


// Start Sentry
Sentry.init({
  dsn: 'https://6346cd563d804b609812ca4d902e119f@o451119.ingest.sentry.io/5437669',
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 0.2,
  environment:
    document.location.host === 'www.nvisioncenters.com' ? 'production' : 'development',
  allowUrls: [/nvisioncenters\.com/],
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const DESKTOP_HEADER_HEIGHT = 184;
const useScroll = () => {
  let isShown = false;
  const handleScroll = () => {
    const { scrollY } = window;

    // Back to top show/hide
    if (scrollY > DESKTOP_HEADER_HEIGHT && !isShown) {
      document.body.classList.add('Body--scrolled');
      isShown = true;
    } else if (scrollY <= DESKTOP_HEADER_HEIGHT && isShown) {
      document.body.classList.remove('Body--scrolled');
      isShown = false;
    }
  };
  handleScroll();
  document.addEventListener('scroll', handleScroll);
};

useReady(() => {
  // console.log('DOM ready, initializing components');
  const form = document.querySelector('[data-plugin="nv-form"]');
  // console.log('Found form:', form);
  if (form) {
    // console.log('Form attributes:', {
    //   id: form.id,
    //   type: form.getAttribute('data-type'),
    //   name: form.getAttribute('data-name')
    // });
  }

  initTracking();
  initFooter();
  initLocationSearch();
  initSurgeon();

  initNav();
  useScroll();

  /** @TODO make it webpackChunk */
  const scheduler = document.getElementById('scheduler');
  if (scheduler) {
    import(/* webpackChunkName: 'scheduler' */ './scheduler/index.js').then(
      ({ default: initScheduler }) => { initScheduler() });
  }

  const sliders = document.querySelectorAll('[data-plugin="slider"]');
  if (sliders?.length) {
    import(/* webpackChunkName: 'slider' */ './utils/slider.js').then(
      ({ default: init }) => init(sliders)
    );
  }

  const isModal = !!document.querySelector('.Modal');
  if (isModal) {
    import(/* webpackChunkName: 'modal' */ './modal/Modal.js').then(({ default: init }) =>
      init()
    );
  }

  if (document.getElementById('lasik-calculator')) {
    import(/* webpackChunkName: 'lasik-calculator' */ './blocks/LasikCalculator/LasikCalculator.js').then(({ default: LasikCalculator }) => {
      LasikCalculator()
    })
  }

});
